var it = {
  "Add Quantity Breaks to your product page": "Aggiungi sconti quantità alla tua pagina prodotto",
  "Add Upsell.com to your ": "Aggiungi Upsell.com alla tua ",
  "Add to cart click": "Clic su Aggiungi al carrello",
  "All time": "Tutto il tempo",
  "and select": "e seleziona",
  "button": "pulsante",
  "Cart drawer page": "Pagina del cassetto del carrello",
  "Cart page": "Pagina del carrello",
  "Check status": "Verifica stato",
  "Checkout page": "Pagina di checkout",
  "Checkout click": "Clic su Checkout",
  "Click": "Clicca su",
  "Click on": "Clicca su",
  "Click the": "Clicca sul",
  "Custom slot": "Slot personalizzato",
  "Custom slots": "Slot personalizzati",
  "Custom Slots": "Slot personalizzati",
  "Enable in theme editor": "Abilita nell’editor del tema",
  "contact support.": "contatta il supporto.",
  "from the right sidebar": "dalla barra laterale destra",
  "Go to App Embeds": "Vai a Incorporamenti app",
  "Go to your Cart drawer page": "Vai alla tua pagina del cassetto del carrello",
  "Go to your Cart page": "Vai alla tua pagina del carrello",
  "Go to your Checkout page": "Vai alla tua pagina di checkout",
  "Go to your Order status page": "Vai alla tua pagina di stato dell'ordine",
  "Go to your Post purchase page": "Vai alla tua pagina post-acquisto",
  "Go to your Product page": "Vai alla tua pagina prodotto",
  "Go to your Thank you page": "Vai alla tua pagina di ringraziamento",
  "items": "articoli",
  "in the left sidebar": "nella barra laterale sinistra",
  "Last 12 months": "Ultimi 12 mesi",
  "Last 30 days": "Ultimi 30 giorni",
  "Last 365 days": "Ultimi 365 giorni",
  "Last 7 days": "Ultimi 7 giorni",
  "Last 90 days": "Ultimi 90 giorni",
  "Last month": "Mese scorso",
  "Last year": "Anno scorso",
  "Make sure": "Assicurati che",
  "Need assistance? Contact our support team for help.": "Hai bisogno di assistenza? Contatta il nostro team di supporto.",
  "Order status page": "Pagina di stato dell'ordine",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "La nostra app sta subendo un po' di magia per migliorare la tua esperienza.",
  "Post purchase page": "Pagina post-acquisto",
  "Product page": "Pagina prodotto",
  "Save": "Salva",
  "Scroll to the bottom and select": "Scorri fino in fondo e seleziona",
  "Select": "Seleziona",
  "Success. Please continue.": "Successo. Per favore continua.",
  "Thank you page": "Pagina di ringraziamento",
  "The Upsell.com team.": "Il team di Upsell.com.",
  "The Upsell.com widget is not placed on ": "Il widget Upsell.com non è posizionato su ",
  ". Please follow the steps above or ": ". Per favore segui i passaggi sopra oppure ",
  "Today": "Oggi",
  "toggle is on": "l'interruttore sia attivo",
  "Total": "Totale",
  "under": "sotto",
  "We apologize for any inconvenience caused,": "Ci scusiamo per il disagio causato,",
  "We apologize for any inconvenience caused.": "Ci scusiamo per il disagio causato.",
  "We'll be done in a few minutes!": "Finiremo tra pochi minuti!",
  "We're improving our services!": "Stiamo migliorando i nostri servizi!",
  "Widget already added": "Widget già aggiunto",
  "Yesterday": "Ieri",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Hai attivato il widget nel tuo negozio online, ma non l'hai salvato nell'editor Upsell",
  "You placed the widget on the ": "Hai posizionato il widget su ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", ma non l'hai salvato nell'editor di Shopify. Per favore torna a ",
  " and save the changes.": " e salva le modifiche."
};

export { it as default };
//# sourceMappingURL=it.json.js.map
